export const RELATED_MANAGER_FORM_FIELDS = {
  SELECTED_MANAGER: 'selected_manager',
  SELECTED_SECTOR: 'selected_sector',
};
